/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { Checkbox, Switch } from "antd";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import CustomLayout from "../../../../Core/Layout/CustomLayout";
import Button from "../../../../Core/Components/CustomButton";
import { CustomInputWithController } from "../../../../Core/Components/CustomInput";
import { PopoverDropdown } from "../../../../Core/Components/CustomDropdown";
import { addFarmerV3, editFarmerV3 } from "../../../../Redux/APIs/usersAPI";
import { PARTNER_ROLE, farmerRoleOptions } from "../../Data";
import useLocationOnAdd from "../useLocationOnAdd";
import PlusIcon from "../../../../Common/Svgs/PlusIcon";
import { updateUsers } from "../../../../Redux/Slices/users.slice";
import PhotoUpload from "../PhotoUpload";
import {
  COUNTRY_CONFIGS,
  DEFAULT_COUNTRY,
} from "../../../../Config/countryConfig";
import {
  parsePhoneNumber,
  getCountryConfigByDialCode,
  validatePhoneNumberLength,
} from "../../../../Utils/phoneNumberHelper";
import DialCodeSelector from "../../../../Core/Components/DialCodeSelector";

const LabelAndInput = ({
  label,
  control,
  formState,
  name,
  placeholder,
  rules,
  focus,
  setFocus,
  intent = "createUser",
  customOnChange = null,
  disabled = false,
  prefix = null,
}) => {
  return (
    <div className="">
      <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
        {label}
      </p>
      <CustomInputWithController
        intent={intent}
        control={control}
        formState={formState}
        focus={focus}
        setFocus={(e) => setFocus(e)}
        name={name}
        placeholder={placeholder}
        rules={rules}
        customOnChange={customOnChange}
        isFieldDisabled={disabled}
        prefix={prefix}
      />
    </div>
  );
};

const AddFarmer = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const dispatch = useDispatch();

  const { currentFarmer } = useSelector((state) => state.users);
  const { locationDetails } = useSelector((state) => state.loggedInUser);

  const detectedCountry =
    COUNTRY_CONFIGS.find((c) => c.code === locationDetails?.countryCode) ||
    DEFAULT_COUNTRY;

  const parsedContact = id ? parsePhoneNumber(currentFarmer?.contactNo) : null;
  const parsedMpesa = id ? parsePhoneNumber(currentFarmer?.mpesaNo) : null;

  // main form
  const {
    handleSubmit,
    control,
    formState,
    setValue,
    clearErrors,
    reset,
    setError,
    watch,
    trigger,
    register,
    // getValues,
  } = useForm({
    defaultValues: {
      firstName: id ? currentFarmer.firstName : "",
      lastName: id ? currentFarmer.lastName : "",
      uniqueId: id ? currentFarmer?.uniqueId : "",
      roleId: id ? currentFarmer.role : 1,
      roleValue: id
        ? currentFarmer.role === PARTNER_ROLE.FARMER
          ? "Farmer"
          : "Offtaker"
        : "Farmer",
      contactNumberDialCode: id
        ? parsedContact?.dialCode || detectedCountry.dialCode
        : detectedCountry.dialCode,
      contactNumber: id ? parsedContact?.contactNumber || "" : "",
      collectionPointName: id ? currentFarmer.locationName : "",
      collectionPointId: id ? currentFarmer.locationId : "",
      latLongArray: currentFarmer?.farms?.length
        ? currentFarmer.farms
        : [
            {
              lat: null,
              long: null,
            },
          ],
      gender: id ? currentFarmer?.gender ?? "male" : "male",
      mpesaNumberDialCode: id
        ? parsedMpesa?.dialCode || detectedCountry.dialCode
        : detectedCountry.dialCode,
      mpesaNumber: id ? parsedMpesa?.contactNumber || "" : "",
      sameNumber: id ? currentFarmer?.sameNumber : false,
      idUrl: id ? currentFarmer?.idUrl : "",
    },
  });

  register("contactNumberDialCode");
  register("mpesaNumberDialCode");

  const contactNumberDialCode = watch("contactNumberDialCode") || "+254";
  const contactCountryConfig = getCountryConfigByDialCode(
    contactNumberDialCode,
  );
  const contactPlaceholder =
    contactCountryConfig?.placeholder || "Enter Number";

  const mpesaNumberDialCode = watch("mpesaNumberDialCode") || "+254";
  const mpesaCountryConfig = getCountryConfigByDialCode(mpesaNumberDialCode);
  const mpesaPlaceholder = mpesaCountryConfig?.placeholder || "Enter Number";

  const { fields, append } = useFieldArray({
    control,
    name: "latLongArray",
  });

  const [focus, setFocus] = useState({
    firstName: false,
    lastName: false,
    uniqueId: false,
    contactNumber: false,
    mpesaNumber: false,
  });

  const [focusState, setFocusState] = useState([]);
  const [powerAfricaAgent, setPowerAfricaAgent] = useState(false);
  const [upload, setUpload] = useState({
    loading: false,
    error: "",
    progress: 0,
    name: "",
  });

  const rules = { required: "Required." };

  const locationListForFarmers = useLocationOnAdd(watch);

  const roleError = formState?.errors?.roleValue?.message;
  const collectionPointError = formState?.errors?.collectionPointName?.message;

  const handleLatLongFocus = (index, field, state) => {
    setFocusState((prevState) => {
      const updatedFocusState = [...prevState];

      // if object for given index does not exists, then add it
      if (!updatedFocusState[index]) {
        updatedFocusState[index] = { lat: false, long: false };
      }

      // Update the specific field's (given index) focus state
      updatedFocusState[index][field] = state;

      return updatedFocusState;
    });
  };

  const getGenderStyles = (type = "male") => {
    const current = watch("gender");
    if (type === "male" && current === "male") return "bg-green text-white";
    if (type === "female" && current === "female") return "bg-green text-white";
    return "bg-green-10 text-green hover:bg-green-20";
  };

  const onCancel = () => {
    navigate("/users?tab=partners");
    dispatch(
      updateUsers({
        key: "currentFarmer",
        value: {},
      }),
    );
  };

  const handleLicenseUpload = async (options) => {
    const { onError, onSuccess, file } = options;

    const formData = new FormData();

    formData.append("files", file);
    if (id) formData.append("farmerId", id);

    if (file?.size > 2000000) {
      setError((prev) => ({
        ...prev,
        error:
          "File size is too high. Try compressing the image and upload again.",
      }));

      return;
    }

    try {
      setUpload((prev) => ({ ...prev, loading: true, name: file?.name }));

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/farmers/upload-id`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          onUploadProgress: (e) =>
            setUpload((prev) => ({
              ...prev,
              progress: Math.round((e.loaded * 100) / e.total),
            })),
        },
      );

      if (response.status === 200) {
        setValue("idUrl", response.data.fileUrl);
        onSuccess(response.data);
      }
    } catch (error) {
      console.log(error);
      onError(error);
    } finally {
      setUpload((prev) => ({
        ...prev,
        loading: false,
        error: "",
        progress: 0,
      }));
    }
  };

  const onAdd = async (e) => {
    const payload = {
      ...e,
      contactNumber: `${e.contactNumberDialCode}${e.contactNumber}`,
      mpesaNumber: `${e.mpesaNumberDialCode}${e.mpesaNumber}`,
    };
    delete payload.contactNumberDialCode;
    delete payload.mpesaNumberDialCode;

    if (e.latLongArray.some((item) => !item.lat)) {
      payload.latLongArray = [];
    }

    if (id) {
      payload.farmerId = id;
      const editResponse = await dispatch(editFarmerV3(payload));

      if (
        editResponse?.payload?.response &&
        editResponse?.payload?.response?.status !== 200
      ) {
        setError("contactNumber", {
          type: "server",
          shouldFocus: true,
          message: editResponse?.payload?.response?.data?.message,
        });
      } else {
        reset();
        navigate("/users?tab=partners");
      }
    } else {
      const addResponse = await dispatch(addFarmerV3(payload));

      if (
        addResponse?.payload?.response &&
        addResponse?.payload?.response?.status !== 200
      ) {
        setError("contactNumber", {
          type: "server",
          shouldFocus: true,
          message: addResponse?.payload?.response?.data?.message,
        });
      } else {
        reset();
        navigate("/users?tab=partners");
      }
    }
  };

  useEffect(() => {
    if (currentFarmer && currentFarmer?.farms?.length) {
      setPowerAfricaAgent(true);
    }
  }, [currentFarmer]);

  return (
    <CustomLayout pageName="Users" hideFooter>
      <div className="px-6 pt-6 bg-background-white">
        <div className="flex items-center justify-between pb-6">
          <p className="font-poppins text-base font-medium capitalize">
            {id ? "Edit Partner" : "Add a new partner"}
          </p>

          <div className="flex items-center gap-x-3">
            <Button
              size="filter"
              width="generateUser"
              colors="grey"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              size="filter"
              width="generateUser"
              type="submit"
              onClick={handleSubmit(onAdd)}
            >
              {id ? "Save" : "Add"} Partner
            </Button>
          </div>
        </div>

        <div className="w-full bg-light-grey h-[1px]" />
      </div>

      <div className="h-[calc(100vh-88px-72px)] bg-background-white p-6 flex flex-col gap-y-6 overflow-y-scroll">
        <LabelAndInput
          label="First Name"
          control={control}
          formState={formState}
          name="firstName"
          placeholder="Enter Name"
          rules={rules}
          focus={focus.firstName}
          setFocus={(state) => setFocus({ ...focus, firstName: state })}
        />

        <LabelAndInput
          label="Last Name"
          control={control}
          formState={formState}
          name="lastName"
          placeholder="Enter Name"
          rules={rules}
          focus={focus.lastName}
          setFocus={(state) => setFocus({ ...focus, lastName: state })}
        />

        <div>
          <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
            Gender
          </p>

          <div className="flex items-center gap-x-2">
            <div
              role="button"
              onClick={() => setValue("gender", "male")}
              className={`h-[34px] px-4 flex items-center rounded-md transform transition-colors duration-200
                ${getGenderStyles("male")}
                `}
            >
              <p className="font-poppins font-medium text-xs">Male</p>
            </div>

            <div
              role="button"
              onClick={() => setValue("gender", "female")}
              className={`h-[34px] px-4 flex items-center rounded-md transform transition-colors duration-200
                ${getGenderStyles("female")}
                `}
            >
              <p className="font-poppins font-medium text-xs">Female</p>
            </div>
          </div>
        </div>

        <div className="">
          <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
            Role
          </p>
          <Controller
            name="roleValue"
            rules={rules}
            control={control}
            render={({ field }) => (
              <PopoverDropdown
                {...field}
                placeholder="Select Role"
                formState={formState}
                options={farmerRoleOptions}
                onSelect={(data) => {
                  setValue("roleId", data.id);
                  setValue("roleValue", data.value);
                  clearErrors("roleValue");
                }}
              />
            )}
          />

          <p
            className={`font-poppins text-xs font-light capitalize leading-4.5 ${
              roleError ? "text-alert-red visible mt-2" : "invisible"
            }`}
          >
            {roleError}
          </p>
        </div>

        <LabelAndInput
          label="Contact Number"
          control={control}
          formState={formState}
          name="contactNumber"
          placeholder={contactPlaceholder}
          focus={focus.contactNumber}
          setFocus={(state) => setFocus({ ...focus, contactNumber: state })}
          rules={{
            required: "Required.",
            validate: {
              isNumber: (value) => {
                if (!value) return true;
                return /^\d+$/.test(value) || "Please enter only numbers";
              },
              isValidLength: (value) =>
                validatePhoneNumberLength(value, watch("contactNumberDialCode")),
            },
          }}
          customOnChange={(e) => {
            if (watch("sameNumber")) {
              setValue("mpesaNumber", e);
              clearErrors("mpesaNumber");
            }
          }}
          prefix={
            <DialCodeSelector
              value={watch("contactNumberDialCode")}
              onChange={(val) => {
                setValue("contactNumberDialCode", val);
                if (watch("sameNumber")) {
                  setValue("mpesaNumberDialCode", val);
                }
                trigger("contactNumber");
                if (watch("sameNumber")) {
                  trigger("mpesaNumber");
                }
              }}
            />
          }
        />

        <div>
          <LabelAndInput
            label="Mpesa Number"
            control={control}
            formState={formState}
            name="mpesaNumber"
            placeholder={mpesaPlaceholder}
            focus={focus.mpesaNumber}
            setFocus={(state) => setFocus({ ...focus, mpesaNumber: state })}
            disabled={watch("sameNumber")}
            rules={{
              required: "Required.",
              validate: {
                isNumber: (value) => {
                  if (!value) return true;
                  return /^\d+$/.test(value) || "Please enter only numbers";
                },
                isValidLength: (value) =>
                  validatePhoneNumberLength(value, watch("mpesaNumberDialCode")),
              },
            }}
            prefix={
              <DialCodeSelector
                value={watch("mpesaNumberDialCode")}
                onChange={(val) => {
                  setValue("mpesaNumberDialCode", val);
                  trigger("mpesaNumber");
                }}
                disabled={watch("sameNumber")}
              />
            }
          />

          <div
            role="button"
            className="mt-2 flex items-center gap-x-3 max-w-max"
            onClick={() => {
              const current = watch("sameNumber");
              if (!current) {
                setValue("mpesaNumber", watch("contactNumber"));
                setValue("mpesaNumberDialCode", watch("contactNumberDialCode"));
                clearErrors("mpesaNumber");
              }
              setValue("sameNumber", !current);
            }}
          >
            <Checkbox checked={watch("sameNumber")} />

            <p className="font-aileron font-semibold text-xs text-dark-gray">
              Same As Contact Number
            </p>
          </div>
        </div>

        <div>
          <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
            {watch("roleId") == PARTNER_ROLE.OFFTAKER
              ? "Delivery Point"
              : "Collection Point"}
          </p>

          <Controller
            name="collectionPointName"
            control={control}
            rules={rules}
            render={({ field }) => (
              <PopoverDropdown
                {...field}
                enableSearch
                searchPlaceholder="Search Location"
                placeholder="Select Location"
                className="max-h-[300px] overflow-y-scroll"
                formState={formState}
                options={locationListForFarmers}
                onSelect={(data) => {
                  setValue("collectionPointName", data.value);
                  setValue("collectionPointId", data.id);
                  clearErrors("collectionPointName");
                }}
              />
            )}
          />
          <p
            className={`font-poppins text-xs font-light capitalize leading-4.5 mt-2 ${
              collectionPointError ? "text-alert-red visible" : "invisible"
            }`}
          >
            {collectionPointError}
          </p>
        </div>

        <p className="font-poppins text-xs font-medium pb-2 border-b border-light-grey w-[367px] capitalize">
          ID Card Details
        </p>

        <LabelAndInput
          label="Unique ID"
          control={control}
          formState={formState}
          name="uniqueId"
          placeholder="Enter Unique ID"
          rules={rules}
          focus={focus.uniqueId}
          setFocus={(state) => setFocus({ ...focus, uniqueId: state })}
        />

        <PhotoUpload
          identifier="idUrl"
          upload={upload}
          setUpload={setUpload}
          url={watch("idUrl")}
          setValue={setValue}
          handleLicenseUpload={handleLicenseUpload}
        />

        <p className="font-poppins text-xs font-medium pb-2 border-b border-light-grey w-[367px] capitalize">
          Farm Details
        </p>

        <div className="flex items-center justify-between w-[367px]">
          <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
            Power Africa
          </p>

          <Switch
            checked={powerAfricaAgent}
            onChange={() => setPowerAfricaAgent((prev) => !prev)}
            className="bg-background"
          />
        </div>

        {powerAfricaAgent ? (
          <div>
            {fields.map((farm, index) => (
              <div key={farm.id} className="w-[367px]">
                <div className="w-full">
                  <div className="flex items-center justify-between mb-1.5">
                    <p className="font-aileron text-xs font-normal text-dark-gray capitalize">
                      Latitude & Longitude Of Farm {index + 1}
                    </p>
                  </div>

                  <div className="flex items-start gap-x-2">
                    <CustomInputWithController
                      intent="primary"
                      control={control}
                      formState={formState}
                      name={`latLongArray.${index}.lat`}
                      placeholder="Enter Latitude"
                      rules={{
                        required: "Required.",
                        validate: {
                          isNumber: (value) => {
                            return (
                              (value <= 90 && value >= -90) ||
                              "Latitude can only be a number"
                            );
                          },
                        },
                      }}
                      focus={focusState[index]?.lat}
                      setFocus={(state) =>
                        handleLatLongFocus(index, "lat", state)
                      }
                      error={
                        formState?.errors?.latLongArray?.[index]?.lat?.message
                      }
                    />

                    <CustomInputWithController
                      intent="primary"
                      control={control}
                      formState={formState}
                      name={`latLongArray.${index}.long`}
                      placeholder="Enter Longitude"
                      rules={{
                        required: "Required.",
                        validate: {
                          isNumber: (value) => {
                            return (
                              (value <= 90 && value >= -90) ||
                              "Longitude can only be a number"
                            );
                          },
                        },
                      }}
                      focus={focusState[index]?.long}
                      setFocus={(state) =>
                        handleLatLongFocus(index, "long", state)
                      }
                      error={
                        formState?.errors?.latLongArray?.[index]?.long?.message
                      }
                    />
                  </div>
                </div>
              </div>
            ))}

            <button
              type="button"
              className="py-1 px-2 mt-6"
              onClick={() => {
                append({
                  lat: null,
                  long: null,
                });
              }}
            >
              <div className="flex items-center gap-x-2">
                <p className="font-poppins text-xs font-medium text-primary">
                  Add Another Farm
                </p>
                <PlusIcon className="w-4 h-4 stroke-primary" />
              </div>
            </button>
          </div>
        ) : null}
      </div>
    </CustomLayout>
  );
};

export default AddFarmer;
